import { FieldProps, getIn } from 'formik';
import _ from 'lodash';
import * as React from 'react';
import InputMask from 'react-input-mask';
import { BaseInput, IBaseInputProps } from '../../input';

type PhoneFieldProps = IBaseInputProps & {
    field: FieldProps<any>;
    onMaskChange: (value: string) => void;
};

/**
 * Wrapper around PhoneField to be able to work with Form components
 */
export const PhoneField = React.memo<PhoneFieldProps>(props => {
    const {
        field: {
            field: { name, onBlur, value: fieldValue },
            form: { errors, touched: formTouched },
        },
        readOnly,
        onMaskChange,
        ...otherProps
    } = props;

    React.useEffect(() => {
        setStateValue(fieldValue);
    }, [fieldValue]);

    const [stateValue, setStateValue] = React.useState(fieldValue);

    const error = getIn(errors, name);
    const touched = getIn(formTouched, name);

    const errorMessage: string | undefined = touched && error ? error : undefined;

    const value = _.isNil(stateValue) ? '' : stateValue; // avoid null or undefined values

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setStateValue(e.target.value);
    };

    const handleBlur = (e: React.ChangeEvent<any>): void => {
        onBlur(e); // To set 'touched'
        onMaskChange(e.target.value);
    };

    const renderInput = (): React.ReactElement => {
        return <BaseInput readOnly={readOnly} {...otherProps} errorMessage={errorMessage} name={name} />;
    };

    return (
        <InputMask
            readOnly={readOnly}
            disabled={otherProps.disabled}
            mask="+1 (999) 999-9999"
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            name={name}>
            {(): React.ReactElement => renderInput()}
        </InputMask>
    );
});
